module.exports = __webpack_public_path__ + "img/HandyServices.adcd27e2.jpeg";